var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircularProgress = function SvgCircularProgress(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "251.5px",
    height: "252.5px",
    viewBox: "24 3.5 251.5 252.5",
    enableBackground: "new 24 3.5 251.5 252.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9771,
    y1: 162.8809,
    x2: 137.3776,
    y2: 161.4803,
    gradientTransform: "matrix(103.923 0 0 -60 -13983.1445 9754.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CFCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14C0D4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_)",
    strokeWidth: 8,
    d: "M150,10c42.872,0,82.487,22.872,103.923,60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.2197,
    y1: 164.7021,
    x2: 146.2197,
    y2: 163.2045,
    gradientTransform: "matrix(16.077 0 0 -120 -2063.9299 19804.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14C0D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B2D8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_)",
    strokeWidth: 8,
    d: "M253.923,70c21.437,37.128,21.437,82.872,0,120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.3813,
    y1: 162.3389,
    x2: 135.979,
    y2: 160.9365,
    gradientTransform: "matrix(103.923 0 0 -60 -13983.1445 9934.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16B2D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#19A3DD"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_)",
    strokeWidth: 8,
    d: "M253.923,190c-21.436,37.128-61.051,60-103.923,60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.0166,
    y1: 160.9365,
    x2: 135.6161,
    y2: 162.3371,
    gradientTransform: "matrix(103.923 0 0 -60 -14087.0801 9934.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19A3DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C93E2"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_)",
    strokeWidth: 8,
    d: "M150,250c-42.872,0-82.487-22.872-103.923-60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.124,
    y1: 163.2051,
    x2: 143.124,
    y2: 164.7027,
    gradientTransform: "matrix(16.077 0 0 -120 -2287.8501 19804.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C93E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F83E6"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_)",
    strokeWidth: 8,
    d: "M46.077,190c-21.436-37.128-21.436-82.872,0-120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.6152,
    y1: 161.4795,
    x2: 137.0178,
    y2: 162.882,
    gradientTransform: "matrix(103.923 0 0 -60 -14087.082 9754.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F83E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#11CFCF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_)",
    strokeWidth: 8,
    d: "M46.077,70C67.513,32.872,107.128,10,150,10"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircularProgress, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };